import React from 'react';
import {
  BathroomIcon,
  BedRoomIcon,
  DefaultIcon,
  DinnerIcon,
  HallWayIcon,
  KitchenIcon,
  LivingRoomIcon,
  WcIcon
} from '../components/icons';

export const roomTypes = {
  Basement: {
    id: 'bas',
    icon: <DefaultIcon />
  },
  'Bedroom 1': {
    id: 'bd1',
    icon: <BedRoomIcon />
  },
  'Bedroom 2': {
    id: 'bd2',
    icon: <BedRoomIcon />
  },
  'Bedroom 3': {
    id: 'bd3',
    icon: <BedRoomIcon />
  },
  'Bedroom 4': {
    id: 'bd4',
    icon: <BedRoomIcon />
  },
  'Bedroom 5': {
    id: 'bd5',
    icon: <BedRoomIcon />
  },
  'Bathroom 1': {
    id: 'bt1',
    icon: <BathroomIcon />
  },
  'Bathroom 2': {
    id: 'bt2',
    icon: <BathroomIcon />
  },
  'Dining room': {
    id: 'din',
    icon: <DinnerIcon />
  },
  'Entry hall': {
    id: 'eh',
    icon: <HallWayIcon />
  },
  Hallway: {
    id: 'hal',
    icon: <HallWayIcon />
  },
  Kitchen: {
    id: 'kt',
    icon: <KitchenIcon />
  },
  'Living room': {
    id: 'll',
    icon: <LivingRoomIcon />
  },
  'Laundry room': {
    id: 'lr',
    icon: <DefaultIcon />
  },
  'Other type': {
    id: 'ot',
    icon: <DefaultIcon />
  },
  'Stairs 1': {
    id: 'st1',
    icon: <DefaultIcon />
  },
  'Stairs 2': {
    id: 'st2',
    icon: <DefaultIcon />
  },
  Study: {
    id: 'stu',
    icon: <DefaultIcon />
  },
  'WC 1': {
    id: 'wc1',
    icon: <WcIcon />
  },
  'WC 2': {
    id: 'wc2',
    icon: <WcIcon />
  }
};

export const getRoomIconById = (
  roomId: string,
  className?: string
): JSX.Element => {
  const room = Object.values(roomTypes).find(
    roomType => roomType.id === roomId
  );

  return room ? (
    <div className={className}>{room.icon}</div>
  ) : (
    <DefaultIcon className={className} />
  );
};

export default {
  getRoomIconById,
  roomTypes
};
